<template>
  <el-dialog
    title="分账明细"
    :visible="visible"
    width="1200px"
    @close="handleClose"
    @opened="onOpened"
  >
    <!-- 汇总信息 -->
    <el-table :data="summaryTableData" border size="small" class="summary-table">
      <el-table-column prop="investPrice" label="融资金额"></el-table-column>
      <el-table-column prop="planRentRoyaltyPrice" label="计划分账金额"></el-table-column>
      <el-table-column prop="execRentRoyaltyPrice" label="租金已分账金额"></el-table-column>
      <el-table-column label="买断/取消分账">
        <template slot-scope="{ row }">
          {{ row.execOtherRoyaltyPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column prop="execTotalRoyaltyPrice" label="已分账总金额"></el-table-column>
      <el-table-column prop="investPrinciplePrice" label="已收本金" width="100"></el-table-column>
      <el-table-column prop="investProfitPrice" label="已收服务费" width="100"></el-table-column>
      <el-table-column prop="investTotalPrice" label="资方已收合计" width="100"></el-table-column>
      <el-table-column prop="investRepayPrice" label="资方差额回款" width="100"></el-table-column>
    </el-table>

    <!-- 按期分账列表 -->
    <el-table :data="rentRoyaltyList" border size="small" class="detail-table">
      <el-table-column prop="billNum" label="期数" width="60"></el-table-column>
      <el-table-column prop="billDate" label="账单日" min-width="100"></el-table-column>
      <el-table-column prop="rentPrice" label="租金" min-width="70"></el-table-column>
      <el-table-column label="计划分账金额" min-width="80">
        <template slot-scope="{ row }">
          {{ row.royaltyPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="实际分账金额" min-width="80">
        <template slot-scope="{ row }">
          {{ row.execRoyaltyPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="分账状态" min-width="80">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyBillStatusText(row.royaltyStatus) }}
        </template>
      </el-table-column>
      <el-table-column label="分账方式" min-width="100">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyDeliverTypeText(row.royaltyDeliverType) }}
        </template>
      </el-table-column>
      <el-table-column label="分账时间" min-width="150">
        <template slot-scope="{ row }">
          {{ row.royaltyTime || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="本金" width="100">
        <template slot-scope="{ row }">
          {{ row.investPrinciplePrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="服务费" width="100">
        <template slot-scope="{ row }">
          {{ row.investProfitPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="资方应收" width="100">
        <template slot-scope="{ row }">
          {{ row.investTotalPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="资方差额回款" width="100">
        <template slot-scope="{ row }">
          {{ row.investRepayPrice || '–' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 提前买断分账 / 订单取消分账 -->
    <template v-if="otherRoyalty">
      <div class="section-title">
        {{ getZstRoyaltyTypeText(otherRoyalty.royaltyType) }}
      </div>
      <el-table :data="[otherRoyalty]" border size="small" class="detail-table">
        <el-table-column label="分账方式" min-width="120">
          <template slot-scope="{ row }">
            {{ getZstRoyaltyDeliverTypeText(row.royaltyDeliverType) }}
          </template>
        </el-table-column>
        <el-table-column label="分账时间" min-width="150">
          <template slot-scope="{ row }">
            {{ row.royaltyTime || '–' }}
          </template>
        </el-table-column>
        <el-table-column prop="royaltyPrice" label="分账金额" width="100"></el-table-column>
        <el-table-column prop="investPrinciplePrice" label="本金" width="100"></el-table-column>
        <el-table-column prop="investProfitPrice" label="服务费" width="100"></el-table-column>
        <el-table-column prop="investTotalPrice" label="资方应收" width="100"></el-table-column>
        <el-table-column prop="investRepayPrice" label="资方差额回款" width="100"></el-table-column>
      </el-table>
    </template>

    <div slot="footer">
      <el-button type="primary" size="mini" @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getZstOrderDetailAPI } from "../api";
import {
  getZstRoyaltyBillStatusText,
  getZstRoyaltyTypeText,
  getZstRoyaltyDeliverTypeText,
} from "@/enum/dict/zst";

export default {
  name: "RoyaltyDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      detail: null,
    };
  },

  computed: {
    summaryTableData() {
      if (!this.detail) return [];
      return [this.detail];
    },
    rentRoyaltyList() {
      return this.detail ? this.detail.rentRoyaltyList || [] : [];
    },
    otherRoyalty() {
      return this.detail ? this.detail.otherRoyalty : null;
    },
  },

  methods: {
    getZstRoyaltyBillStatusText,
    getZstRoyaltyTypeText,
    getZstRoyaltyDeliverTypeText,

    async onOpened() {
      if (this.orderId) {
        this.detail = await getZstOrderDetailAPI({ id: this.orderId });
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
      this.detail = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-table {
  margin-bottom: 20px;
}
.detail-table {
  margin-bottom: 20px;
}
.section-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 10px;
}
</style>
